import React, { useEffect } from 'react';
import GeoLocationInput, { ICoordinates } from '../../../GeoLocationInput';
import { useDispatch, useSelector } from 'react-redux';
import FilterDuck from '../../../../redux/filters/filter.duck';
import { IGeoLocation } from '../../../../redux/filters/filter.duck.interface';
import { Redux } from '../../../../redux/redux.interface';
import { modifySortFilter } from '../../../../services/filters/utils/Filters.utils';
import { SortOrder, SortType } from '../../../../services/stock/models/stockItems.service.model';

interface ILocationInputProps {
    onChange?: (geoLocation: IGeoLocation, distanceRadius: number) => void;
    isStockSlice?: boolean;
}

const LocationInput = ({ onChange, isStockSlice }: ILocationInputProps) => {
    const dispatch = useDispatch();
    const filters = useSelector((state: Redux) => FilterDuck.getFilters(state));
    const storedGeoLocation = useSelector((state: Redux) => FilterDuck.getGeoLocation(state));
    const getGeoLocationName = useSelector((state: Redux) => FilterDuck.getGeoLocationName(state));
    const distanceRadius = useSelector((state: Redux) => FilterDuck.getDistanceRadius(state));

    const handleSubmit = (geoLocation: ICoordinates, distanceRadius: number, userInput: string) => {
        dispatch(
            FilterDuck.setFilters(
                !storedGeoLocation ? modifySortFilter(filters, SortType.PROXIMITY, SortOrder.ASC) : filters,
                geoLocation,
                distanceRadius,
                userInput
            )
        );
    };

    const handleClear = () => {
        dispatch(FilterDuck.resetGeoLocationProperties());
    };

    useEffect(() => {
        onChange?.(storedGeoLocation, distanceRadius);
    }, [storedGeoLocation, distanceRadius, onChange]);

    return (
        <GeoLocationInput
            onSubmit={handleSubmit}
            onClear={handleClear}
            geoLocation={storedGeoLocation}
            distanceInKm={distanceRadius}
            getGeoLocationName={getGeoLocationName}
            isStockSlice={isStockSlice}
        />
    );
};

export default LocationInput;
